import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "extension-table-component" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Extension Table ")
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { style: {"margin-top":"16px"} }, "Manage Product Extension Table", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Upload CSV ")
const _hoisted_5 = {
  key: 0,
  style: {"padding-top":"7.5px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Upload File")
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", null, "Export to FTP", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "File Type : ", -1)
const _hoisted_9 = { style: {"display":"flex","gap":"10px","padding-bottom":"10px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Please Select")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Category")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Enrichment (Full)")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("New Product (Yesterday Date)")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Pricing")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Inventory")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("New Product (Today Date)")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "ant-pro-table-list-toolbar-container",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-left" }, [
      /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-title" }, "Product Extension Table")
    ])
  ])
], -1)
const _hoisted_19 = {
  key: 0,
  class: "ant-pro-table-list-toolbar",
  style: {"padding":"10px 24px","padding-top":"0"}
}
const _hoisted_20 = { style: {"margin-right":"20px"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_22 = {
  class: "ant-pro-table-list-toolbar",
  style: {"padding":"10px 24px","padding-top":"0"}
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Select Group Category")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Group Category A")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Group Category B")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Export as CSV")
const _hoisted_28 = {
  key: 1,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_29 = /*#__PURE__*/_createVNode("h3", null, "Edit Row", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("label", null, "Enter in YYYY-MM-DD", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("label", null, "Enter in YYYY-MM-DD", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "ant-form-item-label" }, [
  /*#__PURE__*/_createVNode("label", null, "Image Links")
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("h3", null, "Please inser the password to continue", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Check")
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_extension_table_outlined = _resolveComponent("extension-table-outlined")
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")
  const _component_upload_outlined = _resolveComponent("upload-outlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_a_input_password = _resolveComponent("a-input-password")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { href: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_extension_table_outlined),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "CSV" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": _ctx.fileList,
                  "before-upload": _ctx.beforeUpload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_outlined),
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    (_ctx.csvFileLabel !== null && _ctx.csvFileLabel !== undefined && _ctx.csvFileLabel.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.csvFileLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["file-list", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  loading: _ctx.loadingUpload,
                  onClick: _ctx.uploadCsv
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider),
        _hoisted_7,
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_a_select, {
            ref: "select",
            value: _ctx.exportType,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportType = $event)),
            style: {"width":"500px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: "" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "category" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "enrichment_full" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "enrichment_yesterday" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "pricing" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "inventory" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: "today_product" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_a_button, {
            loading: _ctx.exporting,
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doExport()))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      style: {"margin-top":"16px"},
      "body-style": { padding: 0 }
    }, {
      default: _withCtx(() => [
        _hoisted_18,
        (_ctx.selectedRows.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.selectedRows.length) + " Rows Selected", 1),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportSelectedRows())),
                loading: _ctx.exportLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_a_form, {
            "label-col": {span: 4},
            "wrapper-col": {span: 14}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "Category" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: _ctx.groupCategory,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.groupCategory = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "group_a_categories" }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "group_b_categories" }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "PLU Number" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.pluNumber,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.pluNumber = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "Company Code" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.companyCode,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.companyCode = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "Store Code" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.storeCode,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.storeCode = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "Mall Code" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.mallCode,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mallCode = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "Mall Name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.mallName,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.mallName = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "SKU" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.sku,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.sku = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "Product ID" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.productId,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.productId = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { "wrapper-col": {span: 14, offset: 4} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchTable()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { "wrapper-col": {span: 14, offset: 4} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    loading: _ctx.exportFilteredRowsLoading,
                    type: "primary",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.exportFilteredRows()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          size: 'small',
          loading: _ctx.loadingTable,
          columns: _ctx.columns,
          "data-source": _ctx.rows,
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          "row-selection": _ctx.rowSelection
        }, {
          image: _withCtx(({ record }) => [
            _createVNode("a", {
              href: record.signed_image,
              target: "_blank",
              style: {"float":"left"}
            }, [
              _createVNode("img", {
                src: record.signed_image,
                alt: record.name,
                style: {"max-width":"100px","max-height":"100px","display":"block"}
              }, null, 8, ["src", "alt"])
            ], 8, ["href"])
          ]),
          viewMore: _withCtx(({ record }) => [
            _createVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.showViewModal(record)), ["prevent"])
            }, "Edit", 8, ["onClick"]),
            _createVNode(_component_a_divider, { type: "vertical" }),
            (!record.deleteLoading)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "#",
                  style: {"color":"red"},
                  onClick: _withModifiers(($event: any) => (_ctx.deleteRow(record)), ["prevent"])
                }, "Delete", 8, ["onClick"]))
              : _createCommentVNode("", true),
            (record.deleteLoading)
              ? (_openBlock(), _createBlock("a", _hoisted_28, "Deleting..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source", "pagination", "onChange", "row-selection"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[62] || (_cache[62] = ($event: any) => (_ctx.showModal = $event)),
      width: "1200px",
      footer: false,
      title: "Editing Record"
    }, {
      default: _withCtx(() => [
        _hoisted_29,
        _createVNode(_component_a_form, {
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "PLU",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.plu,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editRow.plu = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Company Code",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.company_code,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.editRow.company_code = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Store Code",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.store_code,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.editRow.store_code = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Product ID",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.product_id,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.editRow.product_id = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Product Name",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.product_name,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.editRow.product_name = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Variant Options",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.variant_options,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.editRow.variant_options = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "SKU",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.sku,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.editRow.sku = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Name Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.name_eng,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.editRow.name_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Extended Name Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.extended_name_eng,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.editRow.extended_name_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Brand Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.brand_eng,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.editRow.brand_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Long Description Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.editRow.long_description_eng,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (_ctx.editRow.long_description_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Ingredients Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.editRow.ingredients_eng,
                          "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.editRow.ingredients_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Category Eng",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.editRow.category_eng,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (_ctx.editRow.category_eng = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Price Ringgit",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.price_ringgit,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_ctx.editRow.price_ringgit = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Sale Price Ringgit",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.sale_price_ringgit,
                          "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => (_ctx.editRow.sale_price_ringgit = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Quantity",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "number",
                          value: _ctx.editRow.quantity,
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_ctx.editRow.quantity = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Chilled",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_chilled,
                          "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => (_ctx.editRow.is_chilled = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Frozen",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_frozen,
                          "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => (_ctx.editRow.is_frozen = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Weight",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.weight,
                          "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => (_ctx.editRow.weight = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Length",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.length,
                          "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => (_ctx.editRow.length = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Width",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.width,
                          "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => (_ctx.editRow.width = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Height",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.height,
                          "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => (_ctx.editRow.height = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Volume",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.volume,
                          "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => (_ctx.editRow.volume = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Age Gated",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_age_gated,
                          "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => (_ctx.editRow.is_age_gated = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Non Halal",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.non_halal,
                          "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => (_ctx.editRow.non_halal = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Max Cart Quantity",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.max_cart_quantity,
                          "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => (_ctx.editRow.max_cart_quantity = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Unit Count",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.unit_count,
                          "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => (_ctx.editRow.unit_count = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Unit Type",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.unit_type,
                          "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => (_ctx.editRow.unit_type = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Perishable",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_perishable,
                          "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => (_ctx.editRow.is_perishable = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Consignment",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_consignment,
                          "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => (_ctx.editRow.is_consignment = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Product Origin",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.product_origin,
                          "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => (_ctx.editRow.product_origin = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Product Grade",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.product_grade,
                          "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => (_ctx.editRow.product_grade = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Product Size",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.product_size,
                          "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => (_ctx.editRow.product_size = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "UPC",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.upc,
                          "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => (_ctx.editRow.upc = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Is Published",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.is_published,
                          "onUpdate:checked": _cache[48] || (_cache[48] = ($event: any) => (_ctx.editRow.is_published = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Tax Rate",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.tax_rate,
                          "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => (_ctx.editRow.tax_rate = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Filler 1",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.filler_1,
                          "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => (_ctx.editRow.filler_1 = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Filler 2",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.filler_2,
                          "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => (_ctx.editRow.filler_2 = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Filler 3",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.filler_3,
                          "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => (_ctx.editRow.filler_3 = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Filler 4",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.filler_4,
                          "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => (_ctx.editRow.filler_4 = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Filler 5",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.filler_5,
                          "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => (_ctx.editRow.filler_5 = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Start Publish Date",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.start_publish_date,
                          "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => (_ctx.editRow.start_publish_date = $event))
                        }, null, 8, ["value"]),
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "End Publish Date",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.end_publish_date,
                          "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => (_ctx.editRow.end_publish_date = $event))
                        }, null, 8, ["value"]),
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Preset Publish",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.editRow.preset_publish,
                          "onUpdate:checked": _cache[57] || (_cache[57] = ($event: any) => (_ctx.editRow.preset_publish = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Preset Quantity",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.preset_quantity,
                          "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => (_ctx.editRow.preset_quantity = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Mall Code",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.editRow.mall_code,
                          "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => (_ctx.editRow.mall_code = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      style: {"width":"100%"},
                      "wrapper-col": {
                            span: 24
                        }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32,
                        _createVNode(_component_a_textarea, {
                          value: _ctx.editRow.image_links,
                          "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => (_ctx.editRow.image_links = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-col", "wrapper-col"]),
        _createVNode(_component_a_button, {
          loading: _ctx.updatingRow,
          onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.updateRow())),
          size: "large",
          type: "primary",
          style: {"float":"right"}
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["loading"]),
        _hoisted_34
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showModalExport,
      "onUpdate:visible": _cache[65] || (_cache[65] = ($event: any) => (_ctx.showModalExport = $event)),
      width: "800px",
      footer: false,
      title: "Password Required"
    }, {
      default: _withCtx(() => [
        _hoisted_35,
        _createVNode(_component_a_form, {
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "Password",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.password_export,
                          "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => (_ctx.password_export = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-col", "wrapper-col"]),
        _createVNode(_component_a_button, {
          loading: _ctx.checkPasswordExport,
          onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.checkPassword())),
          size: "large",
          type: "primary",
          style: {"float":"right"}
        }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }, 8, ["loading"]),
        _hoisted_37
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}